import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { getApiErrorMessage } from '../utils/apiError';
import '../App.css';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    setSent(false);

    try {
      await api.post('/auth/request-password-reset', { email: email.trim() });
      setSent(true);
    } catch (err: any) {
      setError(getApiErrorMessage(err, 'Something went wrong'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
      <div className="card" style={{ width: '400px' }}>
        <h2>Forgot password</h2>
        <p style={{ marginTop: '8px', color: '#555', fontSize: '14px' }}>
          Enter your email and we'll send you a link to reset your password.
        </p>

        {sent ? (
          <div className="p-4 bg-emerald-50 text-emerald-700 rounded-xl">
            <p className="font-medium">Check your email</p>
            <p className="text-sm mt-1">
              If an account exists for that email, we've sent a password reset link. It expires in 1 hour.
            </p>
            <p className="text-sm mt-2">
              <Link to="/login" className="text-purple-600 hover:underline">Back to login</Link>
            </p>
          </div>
        ) : (
          <>
            {error && <div style={{ color: 'red', marginBottom: '15px' }}>{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary" disabled={loading} style={{ width: '100%' }}>
                {loading ? 'Sending...' : 'Send reset link'}
              </button>
            </form>
          </>
        )}

        <p style={{ textAlign: 'center', marginTop: '20px', fontSize: '13px' }}>
          <Link to="/login" style={{ color: '#7c3aed', textDecoration: 'none' }}>Back to login</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
